export default {"src":"/_next/static/image/public/images/flags/flag_504.4fe31d6737108a47e1a0219bd023e261.svg","height":16,"width":24};